import React from 'react';
import { Modal } from 'client/components/common/Modal';

type Props = {
  jobBenefitList: JSX.Element;
  handlers: {
    handleClickClose: () => void;
    handleClickClear: () => void;
  };
};

export const JobBenefitModal = ({ jobBenefitList, handlers: { handleClickClear, handleClickClose } }: Props) => {
  return (
    <div data-testid="border-b border-solid border-gray my-0 mx-5">
      <Modal title="求人の特徴" onClose={handleClickClose} onClear={handleClickClear}>
        <div>
          <div className="text-base font-bold text-left mx-5 my-[17px] text-black">{jobBenefitList}</div>
        </div>
      </Modal>
    </div>
  );
};
